import { makeObservable, action, runInAction } from 'mobx';
import { IRoom, RoomRequest, Store } from '@utils';
import { Inject, Service } from 'typedi';

@Service()
export class RoomsStore extends Store<IRoom> {
  @Inject(() => RoomRequest)
  private roomRequest: RoomRequest;

  constructor() {
    super();
    makeObservable(this);
  }

  @action getRooms = () => {
    if (!this.data.length) {
      this.isLoading = true;
      return this.roomRequest.getRooms().then((res) => runInAction(() => {
        res && (this.data = res.data);
        this.isLoading = false;
      }));
    }
  };

  getRoomByCabinetNumber = (cabinetNumber: number) => (
    this.data.find((elem) => elem.cabinetNumber === cabinetNumber)
  );
}
